import React from "react";
import { SidebarProvider, SidebarTrigger } from "../ui/sidebar";
import { AdminAppSidebar, StaffAppSidebar } from "../ui/app-sidebar";
import { Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { InactivityDialogProvider } from "../expire/InactivityDialogProvider";
export function AdminMainLayout() {
  // const { showDialog, stayLoggedIn, setShowDialog } = useAuth();
  return (

    <InactivityDialogProvider >

      <div className="flex min-h-screen w-full">

        <SidebarProvider className="md:flex-row flex-col bg-gray-50">
          <AdminAppSidebar />
          <div className="md:hidden pl-4 pt-4">
            <SidebarTrigger />
          </div>

          <main className="md:w-[calc(100%-16rem)]">

            <Outlet />
          </main>
        </SidebarProvider>
      </div>
    </InactivityDialogProvider >

  );
}
export function StaffMainLayout() {
  return (
    <InactivityDialogProvider >

      <div className="flex min-h-screen w-full">

        <SidebarProvider className="md:flex-row flex-col bg-gray-50">
          <StaffAppSidebar />
          <div className="md:hidden pl-4 pt-4">
            <SidebarTrigger />
          </div>

          <main className="md:w-[calc(100%-16rem)]">
            <Outlet />
          </main>
        </SidebarProvider>
      </div>
    </InactivityDialogProvider >
  );
}
